import type { SorenessLevel } from "./types";

export const SORENESS_LEVELS: readonly SorenessLevel[] = [0, 1, 2, 3, 4];

export function isSorenessLevel(value: number | null): value is SorenessLevel {
  return value !== null && Number.isInteger(value) && value >= 0 && value <= 4;
}
